import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import OnDutyNow from "@/components/OnDutyNow";

/**
 * /team/on-duty — live roster page (clock-ins, whole-day logs, on-duty).
 * The heavy lifting (fetch, filters, map) lives in <OnDutyNow />; this file
 * just wraps it in the standard shell + back-link to keep the routing clean.
 */
export default function OnDuty() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="on-duty-page">
      <div className="flex items-center gap-3 mb-2">
        <Link
          to="/team"
          className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest text-gray-500 hover:text-summit-primary"
          data-testid="on-duty-back-link"
        >
          <ArrowLeft className="w-3 h-3" /> Back to team
        </Link>
      </div>
      <h1 className="font-display text-3xl font-medium tracking-tight" data-testid="on-duty-page-title">
        Live On-Duty Roster
      </h1>
      <p className="text-sm text-gray-500 mt-1 max-w-2xl">
        Everyone currently clocked in, on a whole-day log, or on duty — updated every 60 seconds.
        Managers see their team scope; Senior Managers &amp; Admins see the entire company.
      </p>
      <OnDutyNow />
    </div>
  );
}
